import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"

const name = "JobNotesCard"

type JobNotesCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
    jobCompletion: RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult  | undefined
}

const JobNotesCard: React.FC<JobNotesCardProps> = ({ parent, job, jobDetails, jobCompletion }) => {
    return (
        (< Card sx={{ mb: 1 }}>
            <CardContent>
                {jobDetails?.notes &&
                    <Grid container>
                        <Grid size={12}>
                            <Typography sx={{ textAlign: "left", pr: 2 }} variant="body1" >Notes:</Typography>
                        </Grid>
                        <Grid size={12}>
                            {`${jobDetails.notes}${jobCompletion?.notes ? ("\n" + jobCompletion?.notes) : ""}`.split("\n").map((line, index) => <Typography key={index} variant="body2">{line}</Typography>)}
                        </Grid>
                    </Grid>}
            </CardContent>
        </Card >)
    );
}

JobNotesCard.displayName = name

export default React.memo(JobNotesCard)

